export const ALL = "ALL";
export const BATTERY = "BATTERY";
export const AIR_CONDITIONER = "AIR_CONDITIONER";
export const ACCESS_CONTROL = "ACCESS_CONTROL";
export const CAMERA = "CAMERA";
export const CURTAIN = "CURTAIN";
export const FIRE_ALARM = "FIRE_ALARM";
export const LIGHT = "LIGHT";
export const LIGHT_DIMMER = "LIGHT_DIMMER";
export const LIGHT_METER = "LIGHT_METER";
export const MOTION_SENSOR = "MOTION_SENSOR";
export const POWER_SWITCH = "POWER_SWITCH";
export const ROLLER_BLIND = "ROLLER_BLIND";
export const THERMO_METER = "THERMO_METER";
export const HUMIDITY_SENSOR = "HUMIDITY_SENSOR";
export const TAPLIFE_CONTROLLER = "TAPLIFE_CONTROLLER";
export const DOOR_SENSOR = "DOOR_SENSOR";
export const WEATHER = "WEATHER";
export const OUTLET = "OUTLET";
export const MULTIMEDIA = "MULTIMEDIA";
export const DOORBELL = "DOORBELL";
export const DOORLOCK = "DOORLOCK";
export const HIDDEN_SWITCH = "HIDDEN_SWITCH";
export const SENSOR = "SENSOR";
export const POWER_METER = "POWER_METER";
export const WATER_METER = "WATER_METER";
export const WATERING_SWITCH = "WATERING_SWITCH";
export const ELEVATOR = "ELEVATOR";
export const SIREN = "SIREN";
export const AREA_STATE = "AREA_STATE";
export const SMART_SPEAKER = "SMART_SPEAKER";
export const MALFUNCTION = "MALFUNCTION";
export const LEAK_DETECTOR = "LEAK_DETECTOR";
export const SMOKE_DETECTOR = "SMOKE_DETECTOR";
export const SENSOR_BINARY = "SENSOR_BINARY";
export const VOLTAGE_SENSOR = "VOLTAGE_SENSOR";
export const TOUCH_PANEL = "TOUCH_PANEL";
